<template>
    <div class="sales_manage">
        <div class="sales_header">
            <div class="chouse_wrap">
                <ul class="conditions_list">
                    <li class="conditions_list_item">
                        <!-- <span>房源编号：</span> -->
                        <div class="idcode">
                            <el-input v-model="searchData.houseId" clearable @input="getHouselist(houseInfo,'change')" placeholder="编号、电话、姓名"></el-input>
                        </div>
                    </li>

                    <li class="conditions_list_item">
                        <!-- <span class="list_item_title">小区：</span> -->
                        <div class="Residential">
                            <el-autocomplete popper-class="my-autocomplete" v-model="ResidentialName" :fetch-suggestions="querySearchAsync" placeholder="请输入小区" @clear="searchData.tungId='',searchData.unitId='',pageNumber=1,pageSize=20,currentPage=1,getHouselist(houseInfo,'change')" @select="ResidentialNameChange" clearable>
                                <template slot-scope="{ item }">
                                    <div class="name" @select="handleSelect">{{ item.name }}</div>
                                </template>
                            </el-autocomplete>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                      <el-select v-model="searchData.prefix" placeholder="编号前缀" @change="getHouselist(houseInfo,'change')" clearable>
                        <el-option v-for="(item) in simplePrefix" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <!-- <span>栋座：</span> -->
                        <el-select v-model="searchData.tungId" placeholder="栋座" @visible-change="getSimpleTung" @change="getHouselist(houseInfo,'change')" clearable>
                            <el-option v-for="(item,index) in simpleTungList" :key="index" :label="item.tungNumber" :value="item.tungId"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <!-- <span>单元：</span> -->
                        <el-select v-model="searchData.unitId" placeholder="单元" @visible-change="getSimpleUnit" @change="getHouselist(houseInfo,'change')"> clearable
                            <el-option v-for="(item,index) in simpleUnitList" :key="index" :label="item.unitNumber" :value="item.unitId"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <span>户型：</span>
                        <el-select v-model="searchData.roomNumber" placeholder="请选择" @visible-change="getDoorModelData" @change="getHouselist(houseInfo,'change')" clearable>
                            <el-option v-for="(item,index) in doorModelData" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item total_price_input">
                        <span>面积：</span>
                        <span class="total_inp">
                            <el-input @input="getHouselist(houseInfo,'change')" v-model="searchData.minimumArea"></el-input>—
                            <el-input @input="getHouselist(houseInfo,'change')" v-model="searchData.maximumArea"></el-input>
                        </span>
                    </li>
                    <li class="conditions_list_item total_price_input">
                        <span>租金：</span>
                        <span class="total_inp">
                            <el-input @input="getHouselist(houseInfo,'change')" v-model="searchData.minimumRent"></el-input>—
                            <el-input @input="getHouselist(houseInfo,'change')" v-model="searchData.maximumRent"></el-input>
                        </span>
                    </li>
                    <li class="conditions_list_item total_price_input">
                        <span>楼层：</span>
                        <span class="total_inp">
                            <el-input @input="getHouselist(houseInfo,'change')" v-model="searchData.indexFloor"></el-input>—
                            <el-input @input="getHouselist(houseInfo,'change')" v-model="searchData.lastFloor"></el-input>
                        </span>
                    </li>
                </ul>
                <div class="conditions_list_rigth">
                    <div @click="isTrue = !isTrue" style="display:flex;align-item:center;">
                        <i class="iconfont icon-xiajiantou" :class="{active: isTrue}"></i>
                        <span>更多</span>
                    </div>
                    <div v-if="permisShow('房源新增')" class="sales_contrast_add" @click="addHouse">添加房源</div>
                </div>
            </div>

            <div class="search_list" :class="{active:isTrue}">
                <ul class="conditions_list">
                    <li class="conditions_list_item">
                        <span>建筑类型：</span>
                        <div class="statusInput1">
                            <el-select v-model="searchData.houseResourceType" multiple collapse-tags placeholder="请选择" @visible-change="getHouseType" @change="getHouselist(houseInfo,'change')" clearable>
                                <el-option v-for="item in houseTypeList" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <span>房间号：</span>
                        <div class="idcode">
                            <el-input v-model="searchData.roomNo" clearable @input="getHouselist(houseInfo,'change')"></el-input>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <span>区域：</span>
                        <el-select v-model="searchData.areaId" placeholder="请选择" @visible-change="getRegionData" @change="getHouselist(houseInfo,'change')" clearable>
                            <el-option v-for="(item,index) in regionData" :key="index" :label="item.name" :value="item.areaId"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item conditions_list_item_show">
                        <span>部门：</span>
                        <div class="idcode">
                            <el-input v-model="searchData.partmentName" @focus="departpopshow=!departpopshow" @clear="searchData.partmentName='',searchData.storeId='',getHouselist(houseInfo,'change')" placeholder="不限" clearable></el-input>
                            <div class="departpop" v-show="departpopshow">
                                <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                                    <span class="custom-tree-node" slot-scope="{data}">
                                        <div>
                                            <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                            <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                            <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                            <span>{{ data.name }}</span>
                                        </div>
                                    </span>
                                </el-tree>
                            </div>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <span>员工：</span>
                        <el-autocomplete style="height: 30px;" popper-class="my-autocomplete" v-model="searchData.employeeName" :fetch-suggestions="querySearchAsync1" placeholder="请选择" @select="handleSelect1" clearable>
                            <template slot-scope="{ item }">
                                <div class="name" @select="handleSelect1">{{ item.name }}</div>
                            </template>
                        </el-autocomplete>
                    </li>
                    <li class="conditions_list_item">
                        <span>状态：</span>
                        <div class="statusInput">
                            <el-select v-model="searchData.status" multiple collapse-tags placeholder="请选择" @change="getHouselist(houseInfo,'change')" clearable>
                                <el-option v-for="(item,index) in stateList" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </li>

                    <li class="conditions_list_item">
                        <span>装修：</span>
                        <el-select v-model="searchData.decorationDegree" placeholder="请选择" @visible-change="getDecorateData" @change="getHouselist(houseInfo,'change')" clearable>
                            <el-option v-for="(item,index) in decorateData" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <span>付款方式：</span>
                        <el-select v-model="searchData.paymentMethod" placeholder="请选择" @visible-change="getPayTypeData" @change="getHouselist(houseInfo,'change')" clearable>
                            <el-option v-for="(item,index) in payTypeData" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <span>上架：</span>
                        <el-select v-model="searchData.upDown" placeholder="请选择" @change="getHouselist(houseInfo,'change')" clearable>
                            <el-option v-for="(item,index) in upDownList" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                        </el-select>
                    </li>

                    <li class="conditions_list_item">
                        <div class="icon_box" style="background:#f5f5f5" :class="{active:item.searchShow}" v-for="(item,index) in searchList" :key="index" @click="getsearchShow(item)">
                            <div class="screening_tiaojian">
                                {{item.name}}
                                <div class="chouse_bj"></div>
                                <i class="iconfont iconduihao"></i>
                            </div>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <span>录入时间：</span>
                        <div class="idcode">
                            <el-date-picker v-model="searchData.date" unlink-panels value-format="yyyy-MM-dd" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change="getHouselist(houseInfo,'change')"></el-date-picker>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sales_list_wrap">
            <el-table ref="multipleTable" highlight-current-row @row-click="rowColorclick" :data="houseList" border style="width: 100%" @select="handleSelectionChange" @row-dblclick="gotodetail" @sort-change="buildingInfoIdBtn" :row-class-name="addClass">
                <el-table-column prop="buildingInfoId" label="房源编号" width="90px;" sortable="custom">
                    <template slot-scope="scope">
                        <span style="cursor: pointer;color: #5E75E6" :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}" @click="goHousingDetails(scope.row.buildingInfoId,scope.row.employeeId,scope.row.keyId,scope.row.picture,scope.row.source)">{{scope.row.houseCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="residentialName" label="小区" width="105px" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span style="cursor: pointer;color: #5E75E6" :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}" @click="goBuildDetails(scope.row.residentialAreaId)">{{scope.row.residentialName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mark" label="标识" width="80px">
                    <template slot-scope="scope">
                        <i class="iconfont icon-icon_shangjia" style="color: #35c483;font-size: 18px;" v-if="scope.row.upDown"></i>
                        <i class="iconfont icon-icon_yuechi" style="color: #ff5ccd;font-size: 18px;" v-if="scope.row.keyId"></i>
                        <i class="iconfont icon-icon_shoucang" style="color: #ff8500; font-size: 18px;" v-if="scope.row.whetherCollection"></i>
                        <i class="iconfont icon-icon_tupian" style="color: #ff6666; font-size: 18px;" v-if="scope.row.picture"></i>
                        <i class="iconfont icon-icon_dujia" style="color: #ffac27; font-size: 18px;" v-if="scope.row.source"></i>
                        <i class="iconfont icon_weituo" style="color: #c99d02; font-size: 18px;" v-if="scope.row.whetherEntrust"></i>
                    </template>
                </el-table-column>
                <el-table-column label="完整度">
                  <template slot-scope="scope">
                    <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color': scope.row.integrityColor}">{{scope.row.integrity}}%</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span class="isOrange" :class="{isWorry:scope.row.worryColor,rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.status}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="户型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.houseType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="structureArea" label="面积(㎡)" sortable="custom">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.structureArea}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="租金" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.rentCompany}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="装修">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.decoration}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属层">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.floor}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="性质">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.property}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="朝向">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.orientation}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="部门" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.storeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="经纪人">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.agent}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="建筑类型">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.housingResouceType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="房源类型">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.ownerType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="followUp" label="跟进时间" sortable="custom" width="110px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.jobTractTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inputTime" label="录入时间" sortable="custom" width="110px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.inputTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.buildingInfoId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.remarks}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer_page">
            <div class="sales_header_rigth">
                <div class="sales_contrast" v-if="permisShow('房源对比')" @click="housContrast">
                    <i class="iconfont icon-icon_duibi"></i>
                    <p>房源对比</p>
                </div>
                <div class="sales_contrast" @click="HousingStatistics">
                    <i class="iconfont icon-icon_tongji"></i>
                    <p>房源统计</p>
                </div>
                <div class="sales_contrast" v-if="permisShow('房源导出')" @click="toDao" style="background:#22CA85;">
                    <i class="iconfont icon-icon_daochu"></i>
                    <p>导出</p>
                </div>
                <div class="sales_contrast" @click="collect" style="background:#FF904D;">
                    <i class="iconfont icon_shoucang" style="font-size:24px;"></i>
                    <p>我的收藏</p>
                </div>
            </div>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
        </div>
        <el-dialog title="请选择要导出的信息（多选）" :visible.sync="dialogVisible" width="400px">
            <div class="checkbox-out">
                <div class="checkbox" v-for="(item,index) in checkData" :key="index" style="margin-top: 10px;color:#999999;font-size: 14px ">
                    <input type="checkbox" :id="item.name + ':' +  item.id" :value="item.name + ':' + item.id" v-model="checkList" />
                    <label :for="item.name + ':' +  item.id">{{item.name}}</label>
                </div>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end">
                <el-button @click="cancel" style="background: #999999;color: #ffffff;outline: none;border: none; margin-right: 15px;">取 消</el-button>
                <el-button type="primary" @click="daochu" style="background:#5E75E6;outline: none;border: none; ">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import { dicGet, easypoi } from "@/api";
import {
    departmentFind,
    communityQuery,
    areaQuery,
    storeFind,
    employeeQuery
} from "@/api/manageCenter";
import { houseQuery, simpleTung, simpleUnit } from "@/api/houseManage";
import {
    houseTypeQuery,
    Collect,
    deleteCollect,
    queryCollection,
    excelHouse
} from "@/api/houseManage";
import { macOrpc } from "@/vue/electron";
import {housesSimplePrefix} from "@/mixins/housesSimplePrefix";
export default {
    // name: "房源列表",
    name: "/renthouse",
    mixins: [housesSimplePrefix],
    data() {
        let houseTypes = this.$store.state.houseType;
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            isRowColor: "",
            defaultProps: {
                children: "child"
            },
            departmentList: [], //部门数据
            departpopshow: false, //显示树状图
            upDownList: [
                { valueDesc: "已上架", value: "YES" },
                { valueDesc: "未上架", value: "NO" }
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "当天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            permisList,
            houseTypes,
            houseTypeJudge: true, //判断是否显示单价和总价
            searchHouseType: "", //查询状态房源类型
            houseType: "", //房源类型
            houseId: "", //房源编号
            pageNumber: 1,
            pageSize: 20,
            ResidentialName: "", //选择的小区名字
            houseTypeId: "", //户型编号
            searchList: [

                {
                    name: "钥匙",
                    value: "KEY",
                    valueDesc: "key",
                    searchShow: false
                },
                {
                    name: "图片",
                    value: "PICTURE",
                    valueDesc: "picture",
                    searchShow: false
                },
                {
                    name: "独家",
                    value: "SOLE",
                    valueDesc: "sole",
                    searchShow: false
                },
                {
                    name: "委托",
                    value: "ENTRUST",
                    valueDesc: "entrust",
                    searchShow: false
                },
                {
                    name: "带阳台",
                    value: "WITHBALCONY",
                    valueDesc: "withBalcony",
                    searchShow: false
                },
                {
                    name: "独立卫浴",
                    value: "INDEPENDENTBATHROOM",
                    valueDesc: "independentBathroom",
                    searchShow: false
                }

            ], //条件筛选
            housingProperty: "RENTING", //房源性质(二手房、租房、新房)
            searchData: {
                houseResourceType: [],//建筑类型
                roomNo: "",//房间号
                permissionLevel: "",//级别
                partmentName: "", //部门名称
                houseId: "", //房源编号
                parkingLot: null, //车位
                prefix: null, // 前缀
                key: null, //钥匙
                picture: null, //图片
                sole: null, //独家
                entrust: null, //委托
                schoolHousing: null, //学校
                fullTwo: null, //满二
                fullFive: null, //满五
                only: null, //唯一
                // fullFiveOnly: null, //满五唯一
                withBalcony: null, //带阳台
                independentBathroom: null, //独立卫浴
                houseIdSort: null, //房源编号排序
                areaSort: null, //面积排序
                unitPriceSort: null, //单价排序
                totalPriceSort: null, //总价排序

                followUpSort: null,//跟进时间排序
                inputTimeSort: null,//录入时间排序

                "page.pageNumber": "", //从第几条开始
                "page.pageSize": "", //显示几条
                housingProperty: "RENTING", //房源性质(二手房、租房、新房)
                residentialAreaId: "", //小区编号
                tungId: "",//栋座
                unitId: "",//单元
                roomNumber: "", //室数
                paymentMethod: "", //付款方式
                minimumArea: "", //最小面积
                maximumArea: "", //最大面积
                minimumRent: "", //最大租金
                maximumRent: "", //最大租金
                indexFloor: "", //起始楼层
                lastFloor: "", //结束楼层
                transactionType: "", //交易类型
                housingType: "", //房源类型
                employeeName: "",//name
                employeeId: "", //员工编号
                source: "", //来源
                status: [], //业务状态
                areaId: "", //区域编号
                storeId: "", //部门编号
                decorationDegree: "", //装修状态
                upDown: "", //是否上架
                date: "", //签约日期
                indexTotalPrice: "", //起始总价
                lastTotalPrice: "", //结束总价
                // indexYears: "", //开始年代
                // lastYears: "", //结束年代
                propertyRightNature: "", //产权性质
                features: "" //特性
            }, //搜索列表
            selectData: [], //收藏列表
            storeList: [], //部门列表
            addType: "新增出售",
            houseList: [], //房源列表
            currentPage: 1,
            housingData: [], //小区列表
            simpleTungList: [],//栋座列表
            simpleUnitList: [],//单元列表
            doorModelData: [], //户型列表
            payTypeData: [], //付款列表
            propertyRightNatureList: [], //产权性质列表
            selection: [], //标识
            houseData: [], //房源列表
            decorateData: [], //装修列表
            roomIds: [],
            property: "",
            employeesList: [], //员工列表
            sourceList: [], //来源列表
            stateList: [], //状态列表
            propertyList: [], //物业列表
            houseTypeList: [], //房源类型列表
            regionData: [], //区域列表
            FilterList: [],
            selectHouseData: [], //选中的房源列表
            collectHouseData: [], //收藏的房源列表
            isTrue: false,
            isIndex: -1,
            houseInfo: {
                ascriptionEmployeeId: "",
                transactionType: "SELL",
                // entrustmentState: '',
                regionId: 4,
                residentialAreaId: "", // 小区编号
                houseType: "", //户型编号
                paymentMethod: "", // 付款方式
                minimumArea: "", // 最小面积
                maximumArea: "", // 最大面积
                indexFloor: "", // 楼层开始
                lastFloor: "", // 楼层结束
                keyWord: "", // 关键字
                houseResourceType: [], // 建筑类型
                propertyType: "", // 物业类型
                source: "", // 来源
                status: "", // 状态
                tradeAreaId: "", // 商圈编号
                storeId: "", // 部门编号
                areaId: "", //区域编号
                decorationDegree: "", // 装修程度
                indexTotalPrice: "", // 区间查询：低的总价
                lastTotalPrice: "", // 高的总价
                indexYears: "", // 老的年代
                lastYears: "", // 新的年代
                lowEntrustDate: "", // 委托日期 小的时间
                highEntrustDate: "", // 委托日期 大的时间
                onlineStatus: "" // 房源状态
            },
            total: 0,
            checkList: [],
            dialogVisible: false,
            checkData: [
                { name: "房源编号", id: "buildingInfoId" },
                { name: "小区", id: "residentialName" },
                { name: "状态", id: "status" },
                { name: "户型", id: "houseType" },
                { name: "面积", id: "structureArea" },
                { name: "租金", id: "rentCompany" },
                { name: "装修", id: "decoration" },
                { name: "所属层", id: "floor" },
                { name: "性质", id: "property" },
                { name: "朝向", id: "orientation" },
                { name: "部门", id: "storeName" },
                { name: "经纪人", id: "agent" },
                { name: "建筑类型", id: "housingResouceType" },
                { name: "房源类型", id: "ownerType" },
                { name: "跟进时间", id: "jobTractTime" },
                { name: "录入时间", id: "inputTime" },
                { name: "备注", id: "remarks" }
            ],
            list: {},
            excelName: "",
            json_meta: [
                [
                    {
                        " key ": " charset ",
                        " value ": " utf- 8 "
                    }
                ]
            ]
        };
    },
    mounted() {
        this.$store.state.houseType = "RENTING"
        this.searchData.status = ["URGENTRENT", "RENTING", "RECOMMEND"];
        if (this.$route.query.statuse) {
            this.searchData.status = [];
            this.searchData.status.push(this.$route.query.statuse);
        }
        this.getHouselist();
        this.getStateList(); //查询状态
        this.getdepartmentFindAll(); //查询部门

    },
    activated() {
        this.$store.state.houseType = "RENTING";
        if (this.$route.query.statuse) {
            this.searchData.status = [];
            this.searchData.status.push(this.$route.query.statuse);
        }
        this.getHouselist();
        this.getStateList(); //查询状态
        this.getdepartmentFindAll(); //查询部门
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.iskeep) {
            to.meta.keepAlive = false;
        } else {
            to.meta.keepAlive = true;
        }
        next(vm => { });
    },
    methods: {
        //获取栋座
        getSimpleTung(val) {
            if (val) {
                let params = {
                    residentialAreaId: this.searchData.residentialAreaId,
                    prefix: this.searchData.prefix,
                }
                this.$post(simpleTung, params).then(res => {
                    this.simpleTungList = res.data;
                })
            }
        },
        //获取单元
        getSimpleUnit(val) {
            if (val) {
                let params = {
                    tungId: this.searchData.tungId
                }
                this.$post(simpleUnit, params).then(res => {
                    this.simpleUnitList = res.data;
                })
            }
        },
        //对某行添加颜色
        addClass({ row, rowIndex }) {
            if (row) {
            }
        },
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.buildingInfoId;
        },
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            //cosole.log(23432343423, this.permisList);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //查询部门
        getdepartmentFindAll() {
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },
        //选择部门
        handleNodeClick(node, data) {
            this.pageNumber = 1;
            this.currentPage = 1;
            this.searchData.partmentName = node.name;
            this.searchData.storeId = node.id;
            this.departpopshow = false;
            this.getHouselist(this.houseInfo, "change");
        },
        //条件筛选
        getsearchShow(val) {
            if (val.searchShow == false) {
                val.searchShow = true;
                this.searchData[val.valueDesc] = val.value;
                this.getHouselist(this.houseInfo, "change");
            } else {
                val.searchShow = false;
                this.searchData[val.valueDesc] = null;
                this.getHouselist(this.houseInfo, "change");
            }
        },
        //列表排序
        buildingInfoIdBtn(column) {
            this.searchData.houseIdSort = null;
            this.searchData.areaSort = null;
            this.searchData.unitPriceSort = null;
            this.searchData.totalPriceSort = null;

            this.searchData.followUpSort = null;
            this.searchData.inputTimeSort = null;

            if (column.prop == "buildingInfoId" && column.order == "ascending") {
                this.searchData.houseIdSort = 0;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "buildingInfoId" && column.order == "descending") {
                this.searchData.houseIdSort = 1;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "structureArea" && column.order == "ascending") {
                this.searchData.areaSort = 3;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "structureArea" && column.order == "descending") {
                this.searchData.areaSort = 2;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "unitPrice" && column.order == "ascending") {
                this.searchData.unitPriceSort = 5;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "unitPrice" && column.order == "descending") {
                this.searchData.unitPriceSort = 4;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "totalPrice" && column.order == "ascending") {
                this.searchData.totalPriceSort = 7;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "totalPrice" && column.order == "descending") {
                this.searchData.totalPriceSort = 6;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "followUp" && column.order == "ascending") {
                this.searchData.followUpSort = 0;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "followUp" && column.order == "descending") {
                this.searchData.followUpSort = 1;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "inputTime" && column.order == "ascending") {
                this.searchData.inputTimeSort = 0;
                this.getHouselist(this.houseInfo, "change");
            } else if (column.prop == "inputTime" && column.order == "descending") {
                this.searchData.inputTimeSort = 1;
                this.getHouselist(this.houseInfo, "change");
            }
        },
        //导出
        toDao() {
            if (this.houseList.length !== 0) {
                this.dialogVisible = true;
            }
        },
        daochu() {
            if (this.checkList.length === 0) {
                this.$message({
                    type: "error",
                    message: "请选择要导出信息"
                });
            } else {
                let list = [];
                let changList = [];
                this.checkList.map((item, index) => {
                    item = item.split(":");
                    changList.push(item);
                });
                changList.map((item, index) => {
                    list.push(item[1]);
                });
                this.searchData["page.pageNumber"] = this.pageNumber * this.pageSize - this.pageSize;
                this.searchData["page.pageSize"] = this.pageSize;
                let params = Object.assign({}, this.searchData);
                if (params.decorationDegree == "NOT_LIMIT") {
                    params.decorationDegree = null;
                }
                params.field = list;
                params.excelName = "租房列表";
                this.$post(excelHouse, params).then(res => {
                    if (res.success) {
                        let pc = macOrpc();
                        if (!pc) {
                            window.open(this.$uploadUrl + "/erp/contract/template/download?templateAddr=" + res.data);
                        } else {
                            sessionStorage.setItem("downexcel", this.$uploadUrl + "/erp/contract/template/download?templateAddr=" + res.data);
                            sessionStorage.setItem("downexcelName", res.data);
                            this.$electron.ipcRenderer.send("download", this.$uploadUrl + "/erp/contract/template/download?templateAddr=" + res.data);
                        }
                        this.dialogVisible = false;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                })
                this.checkList = [];
            }
        },
        cancel() {
            this.dialogVisible = false;
            this.checkList = [];
        },
        getHouselist(val, flag) {
            this.isRowColor = "";
            if (flag == "change") {
                this.pageNumber = 1;
                this.currentPage = 1;
            }
            // 查询房源列表
            let menu = JSON.parse(localStorage.getItem("menu"));
            if (menu)
                menu.map(item => {
                    if (item.name == "房源管理") {
                        item.childMenus.map(child => {
                            if (
                                this.$store.state.houseType == "RENTING" &&
                                child.name == "租房列表"
                            ) {
                                let arr = [];
                                child.functions.map(func => {
                                    if (func.functionName == "房源查看") {
                                        this.searchData.permissionLevel = func.level;
                                    }
                                    arr.push(func.functionName);
                                    sessionStorage.setItem("permisList", JSON.stringify(arr));
                                    this.permisList = JSON.parse(sessionStorage.getItem("permisList"));
                                });
                            }
                        });
                    }
                });
            this.searchData["page.pageNumber"] = this.pageNumber * this.pageSize - this.pageSize;
            this.searchData["page.pageSize"] = this.pageSize;
            let params = Object.assign({}, this.searchData);
            if (params.decorationDegree == "NOT_LIMIT") {
                params.decorationDegree = null;
            }
            this.$post(houseQuery, params).then(res => {
                if (res.success) {
                    this.houseList = res.data;
                    this.total = res.total;
                    res.data.map((item, index) => {
                        if (item.status == "急售") {
                            item.worryColor = true;
                        }
                        if (item.integrity >= 70) {
                          item.integrityColor = '#3BC588'
                          // item.integrityColor = 'rgb(53, 196, 131)'
                        } else if (item.integrity >= 50) {
                          item.integrityColor = '#9EC947'
                          // item.integrityColor = 'orange'
                        } else if (item.integrity >= 20) {
                          item.integrityColor = '#FDCC01'
                          // item.integrityColor = 'rgb(255, 92, 205)'
                        } else {
                          item.integrityColor = 'red'
                        }
                    });
                } else {
                    this.houseList = res.data;
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },

        // 房间详情
        gotodetail(row, column, event) {
            let result = this.permisShow("房源编辑");
            sessionStorage.setItem("buildId", row.buildingInfoId);
            sessionStorage.setItem("rentHousebuildId", row.buildingInfoId);
            sessionStorage.setItem("employeeId", row.employeeId);
            sessionStorage.setItem("upDown", row.upDown);
            sessionStorage.setItem("keyicon", row.keyId);
            sessionStorage.setItem("picture", row.picture);
            sessionStorage.setItem("source", row.source);
            this.$router.push({ path: "rentingBuildDetail" });
        },
        chouseHouse() {
            this.houseInfo.roomNumber = "";
            this.getHouselist(this.houseInfo);
        },
        // 查询户型
        getDoorModelData(val) {
            if (val) {
                let params = {
                    code: "houseType"
                };
                this.$post(dicGet, params).then(res => {
                    //cosole.log(11, res.data);
                    if (res.success) {
                        this.doorModelData = res.data;
                        //  //cosole.log(res.data);
                    }
                });
            }
        },
        // 选中的房源
        handleSelectionChange(selection, row) {
            this.selectHouseData = [];
            selection.map((item, index) => {
                this.selectHouseData.push(item.buildingInfoId);
            });
            //cosole.log(222, this.selectHouseData);
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        chouseRoom(i, v) {
            if (i === true) {
                this.roomIds.push(v);
            } else {
                this.roomIds.pop(v);
            }
        },
        //房源统计
        HousingStatistics() {
            this.$router.push("/housingStatistics");
            sessionStorage.setItem("housingStatisticsType", "RENTING")
        },

        // 房源对比
        housContrast() {
            if (this.selectHouseData.length > 1) {
                sessionStorage.setItem("roomIds", JSON.stringify(this.selectHouseData));
                this.$router.push("/houseContrast");
            } else {
                this.$message({
                    message: "最少选择2个房源",
                    type: "error"
                });
            }
        },
        //收藏列表
        setCollect(id, collect, deleteid) {
            this.houseId = id;
            if (!collect) {
                //添加收藏
                let params = {
                    houseIds: this.houseId,
                    transactionType: this.housingProperty
                };
                this.$post(Collect, params).then(res => {
                    if (res.success) {
                        this.$message({
                            message: "收藏成功",
                            type: "success"
                        });
                        this.getHouselist();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            } else {
                //取消收藏
                let params = {
                    houseId: this.houseId
                };
                this.$post(deleteCollect, params).then(res => {
                    if (res.success) {
                        this.$message({
                            message: "取消收藏",
                            type: "success"
                        });
                        this.getHouselist();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        //我的收藏
        collect() {
            sessionStorage.setItem("collectHouseType", "RENTING");
            this.$store.commit("delete_clude", "/houseCollect");
            this.$store.commit("delete_tabs", "/houseCollect");
            this.$router.push("/houseCollect");
        },
        addHouse() {
            this.$router.push({ path: "/addRentResidential" });
        },
        // 查询付款方式
        getPayTypeData(val) {
            if (val) {
                if (this.$store.state.houseType == "SECONDHAND") {
                    var house = "secondPaymentMethod";
                } else if (this.$store.state.houseType == "RENTING") {
                    var house = "rentingPaymentMethod";
                }
                let params = { code: house };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.payTypeData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询产权性质
        getPropRightNature() {
            let params = { code: "natureRights" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.propertyRightNatureList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询区域
        getRegionData() {
            let params = {
                // name: data
            };
            this.$post(areaQuery, params).then(res => {
                if (res.success) {
                    this.regionData = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        querySearchAsync(queryString, cb) {
            // 查询小区
            let params = {
                name: queryString
            };
            this.$post(communityQuery, params).then(res => {
                if (res.success) {
                    this.housingData = res.data;
                    let restaurants = this.housingData;
                    // let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
                    cb(restaurants);
                    this.searchData.residentialAreaId = "";
                    this.getHouselist();
                }
            });
        },

        createStateFilter(queryString) {
            // 过滤小区关键字
            return state => {
                return (
                    state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
                );
            };
        },

        handleSelect(item) {
            this.pageNumber = 1;
            this.pageSize = 20;
            this.currentPage = 1;
            this.searchData.residentialAreaId = item.residentialAreaId;
            this.ResidentialName = item.name;
            this.getHouselist();
        },
        // 查询装修
        getDecorateData(val) {
            if (val) {
                let params = { code: "decorationDegree" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.decorateData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询物业
        getPropertyData(val) {
            if (val) {
                let params = {
                    employeeId: this.empId,
                    code: "propertyType"
                };
                this.post(params).then(res => {
                    if (res.success) {
                        //cosole.log(res);
                        this.propertyList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        getStoreList(val) {
            // 获取部门列表
            if (val) {
                let params = {};
                this.$post(storeFind, params).then(res => {
                    if (res.success) {
                        this.storeList = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            }
        },

        // 查询来源
        getSourceList(val) {
            if (val) {
                let params = {
                    code: "source"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.sourceList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询状态
        getStateList(val) {
            let houseType = this.$store.state.houseType;
            if (houseType == "SECONDHAND") {
                this.searchHouseType = "secondBusinessStatus";
            } else if (houseType == "RENTING") {
                this.searchHouseType = "rentingBusinessStatus";
            }
            let params = {
                code: this.searchHouseType
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.stateList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 获取查询添加建筑类型
        getHouseType(val) {
            let that = this;
            if (val) {
                let params = {
                    code: "areaArchitecturalType"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.houseTypeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        querySearchAsync1(queryString, cb) {
            let params = {
                name: queryString,
              status:'ENABLE',
              departmentId:this.searchData.storeId
            };

            this.$post(employeeQuery, params).then(res => {
                if (res.success) {
                  if (res.data.length<=0){
                    this.$message.error('该部门下没有人员！');
                  }
                    this.employeesList = res.data;
                    let restaurants = this.employeesList;
                    cb(restaurants);
                    if (!this.searchData.employeeName) {
                        this.searchData.employeeId = '';
                        this.getHouselist(this.houseInfo, 'change');
                    }

                } else {
                }
            });
        },
        handleSelect1(item) {
            this.searchData.employeeId = item.id;
            this.searchData.employeeName = item.name;
            this.getHouselist(this.houseInfo, 'change');

        },
        // 动态设置class
        setClass(key) {
            let obj = { iconfont: true };
            obj[`${key}`] = true;
            return obj;
        },
        goHousingDetails(id, employeeId, keyId, picture, source) {
            //根据房源类型跳转详情
            if (this.$store.state.houseType == "RENTING") {
                sessionStorage.setItem("buildId", id);
                sessionStorage.setItem("rentHousebuildId", id);
                sessionStorage.setItem("employeeId", employeeId);
                this.$router.push({ path: "rentingBuildDetail" });
            }
        },
        goBuildDetails(id) {
            if (id) {
                let menulist = JSON.parse(localStorage.getItem("menu"));
                let arr = [];
                menulist.map(item => {
                    if (item.name == "管理中心") {
                        item.childMenus.map(child => {
                            if (child.name == "楼盘字典") {
                                child.functions.map(fuc => {
                                    arr.push(fuc.functionName);
                                });
                            }
                        });
                    }
                });
                sessionStorage.setItem("permisList", JSON.stringify(arr));
                sessionStorage.setItem("residentialAreaId", id);
                this.$router.push("/CommunityDetail");
            } else {
                // this.$message({
                //   message: 'aaaa',
                //   type: ''
                // })
            }
        },
        //分页
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageNumber = 1;
            this.pageSize = val;
            this.getHouselist(this.houseInfo); //每页显示条数
        },
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.getHouselist(this.houseInfo); //当前页
        }
    }
};
</script>
<style type="text/css" lang="less">
  .sales_manage{
    .el-autocomplete{
      .el-input__inner{
        height: 30px;
        width: 120px;
      }
    }
  }
.isOrange {
  color: orange;
}
.isWorry {
  color: red;
}
.sales_list_wrap .el-table--border th.is-leaf {
  background: #f2f4ff;
}
.collect {
  width: 100%;
  height: 100%;
  cursor: pointer;
  i {
    color: #707070;
    &.active {
      color: red;
    }
  }
}
.el-checkbox {
  margin-top: 0;
}
.first_el_dropdown_menu {
  .icon-xiajiantou {
    margin-right: 5px;
  }

  .el-dropdown-menu {
    width: 240px;
    height: 280px;
  }

  #add_title {
    font-size: 14px;
    line-height: 14px;
    color: #999999;
    padding-left: 20px;
    margin-top: 5px;
  }

  .el-select-dropdown__list {
    margin-top: 15px;
  }

  .el-select-dropdown__empty {
    margin-top: 15px;
  }

  // .el-popper[x-placement^=bottom] .popper__arrow{
  //   border-top-width: none;
  //   border-bottom-color: none;
  // }
  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    border: none;
  }

  .el-popper[x-placement^="bottom"] {
    margin-top: 0;
  }

  // .el-dropdown-menu__item {
  //   float: left;
  //   width: 33.33%;
  //   display: flex;
  //   flex-direction: column;
  //   line-height: 15px;
  //   padding: 0;
  //   align-items: center;
  //   margin-top: 28px;
  //   color: #5e75e6;
  //   font-size: 14px;
  //   padding-top: 10px;
  // }

  .add_font {
    font-size: 30px;
  }

  .add_sales {
    margin-top: 8px;
  }
}

.sales_manage {
  min-height: 100%;
  position: relative;
  .el-table__row {
    td:nth-child(3) {
      padding: 2px 0 !important;
      text-align: left !important;
    }
  }
  .rowColor {
    color: #fff !important;
  }
  .el-table .cell {
    line-height: 30px;
  }
  .sales_header {
    background: white;
    position: relative;

    .chouse_wrap {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding: 10px 0;
      .conditions_list {
        display: flex;
        flex-flow: wrap;
        align-items: center;
        padding-left: 20px;
        > p {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 10px;
          font-size: 14px;
          color: #bbb;

          > span {
            padding-left: 5px;
          }
        }

        .conditions_list_item {
          display: flex;
          align-items: center;
          margin: 10px 5px;
          .idcode {
            .el-input {
              height: 30px;
              .el-input__inner {
                width: 160px;
                height: 30px;
                // border: none;
                // background: #f5f5f5;
                // padding: 0;
              }
              .el-input__icon {
                line-height: 30px;
              }
            }
          }

          > span {
            // border-right: 1px solid #ccc;
            font-size: 12px;
            // color: #5e75e6;
            // padding: 4px 4px 4px 0;
            min-width: 36px;
          }
          .Residential {
            .el-input__inner {
              width: 120px;
              height: 30px;
              // border: none;
              // background: #f5f5f5;
            }
            .el-input__icon {
              line-height: 30px;
            }
          }

          .el-select {
            // margin-left: 10px;

            .el-input {
              .el-input__inner {
                width: 100px;
                height: 30px;
                // border: none;
                // background: #f5f5f5;
                // padding: 0;
              }

              .el-input__icon {
                line-height: 30px;
              }
            }
          }

          .el-input-group {
            .el-input-group__append {
              padding: 0 19px;
              background: #5e75e6;

              .icon-icon_sousuo {
                color: white;
              }
            }

            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              padding-left: 0;
              border: none;
              width: 120px;
            }
          }

          &.total_price_input {
            display: flex;
            align-items: center;

            .total_inp {
              display: flex;
              align-items: center;
              border: 1px solid #eee;
              border-radius: 3px;
              height: 30px;

              .el-input {
                width: 35px;
                height: 30px;

                .el-input__inner {
                  height: 30px;
                  // background: #f5f5f5;
                  border: none;
                  padding: 0;
                  padding-left: 6px;
                  //   text-align: center;
                }
                .el-input__icon {
                  line-height: 30px;
                }
              }
            }
          }
        }
      }
      .conditions_list_rigth {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 154px;
        .active {
          display: block;
          transform: rotate(180deg);
        }
      }

      // .chouse_box {
      //   display: flex;

      //   .chouse_item {
      //     cursor: pointer;
      //     margin-left: 20px;
      //     text-align: center;

      //     > i {
      //       font-size: 20px;
      //       color: #999999;
      //     }

      //     > p {
      //       font-size: 14px;
      //       margin-top: 5px;
      //       color: #999999;
      //     }

      //     &.active {
      //       > i {
      //         color: #5e75e6;
      //       }

      //       > p {
      //         color: #5e75e6;
      //       }
      //     }
      //   }
      // }

      .sales_line {
        width: 1px;
        height: 40px;
        background: #cccccc;
        margin-left: 10px;
      }

      .chouse_btns {
        margin-left: 20px;
        font-size: 14px;
        color: #999999;

        .sales_empty {
          margin-bottom: 10px;
        }

        > p {
          cursor: pointer;
          display: flex;
          align-items: center;

          > span {
            padding-left: 5px;
          }
        }
      }
    }
    .sales_contrast {
      min-width: 56px;
      padding: 5px 20px;
      background: #f5f5f5;
      margin-right: 34px;
      font-size: 14px;
      color: #ffffff;
      background: #5e75e6;
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      align-items: center;

      .icon-icon_duibi {
        font-size: 24px;
      }
    }
    .sales_contrast_add {
      min-width: 56px;
      padding: 8px 20px;
      margin-left: 6%;
      background: #f5f5f5;
      font-size: 14px;
      color: #ffffff;
      background: #5e75e6;
      border-radius: 3px;
      cursor: pointer;
      .icon-icon_duibi {
        font-size: 24px;
      }
    }

    .search_list {
      width: 100%;
      border-top: 1px solid #ccc;
      display: none;
      padding: 10px 0;
      &.active {
        display: block;
      }
      .input_box .el-range-input {
        background: #ffffff;
      }
      .el-select {
        // margin-left: 20px;
        .el-input {
          .el-input__inner {
            width: 100px;
            height: 30px;
            padding-left: 10px;
            padding-right: 10px;
            border: 1px solid #ccc;
            font-size: 12px;
          }

          .el-input__icon {
            width: 10px;
            line-height: 30px;
            font-size: 12px;
          }
        }
      }

      .conditions_list {
        width: 98%;
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;
        > p {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 10px;
          font-size: 14px;
          color: #bbb;
          > span {
            padding-left: 5px;
          }
        }

        .conditions_list_item {
          margin: 10px;
          display: flex;
          align-items: center;
          color: #000;
          .icon_box {
            padding: 10px 20px;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            margin: 0 5px;
            &.active {
              > div {
                color: #5e75e6;
              }
              .chouse_bj {
                border-color: transparent transparent #5e75e6 transparent;
              }
            }
          }

          .idcode {
            position: relative;
            .el-input {
              // margin-left: 10px;
              .el-input__inner {
                width: 100px;
                height: 30px;
                // border: none;
                // background: #f5f5f5;
                // padding: 0;
              }
              .el-input__icon {
                line-height: 30px;
              }
            }
            .el-range-editor.el-input__inner {
              height: 30px;
              line-height: 30px;
              .el-range-separator {
                height: 30px;
                line-height: 30px;
              }
              .el-input__icon {
                height: 30px;
                line-height: 30px;
              }
            }
          }
          .departpop {
            position: absolute;
            top: 30px;
            z-index: 999;
          }
          .statusInput {
            .el-select {
              .el-input {
                .el-input__inner {
                  width: 140px;
                }
              }
            }
          }
          .statusInput1 {
            .el-select {
              .el-input {
                .el-input__inner {
                  width: 164px;
                }
              }
            }
          }
          > span {
            font-size: 12px;
          }
          .propertyType {
            .el-input__inner {
              width: 85px;
              border: none;
              background: #f5f5f5;
            }
          }

          .el-input-group {
            .el-input-group__append {
              padding: 0 10px;
              background: #5e75e6;

              .icon-icon_sousuo {
                color: white;
              }
            }

            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              padding-left: 0;
              border: none;
              width: 120px;
            }
          }

          .screening_tiaojian {
            font-size: 12px;

            .chouse_bj {
              border-style: solid;
              border-width: 10px 10px 10px 10px;
              border-color: transparent transparent #bbb transparent;
              width: 0px;
              height: 0px;
              transform: rotate(45deg);
              // width: 10px;
              // height: 10px;
              background: #ccc;
              // border: 1px solid red;
              position: absolute;
              top: -10px;
              right: -10px;
            }

            .iconduihao {
              font-size: 12px;
              position: absolute;
              right: -3px;
              top: -1px;
              color: white;
            }
          }

          &.total_price_input {
            display: flex;
            align-items: center;

            .total_inp {
              display: flex;
              align-items: center;
              border: 1px solid #eee;
              border-radius: 3px;
              .el-input {
                width: 80px;
                height: 30px;

                .el-input__inner {
                  height: 30px;
                  // background: #f5f5f5;
                  border: none;
                  padding: 0;
                  padding-left: 6px;
                  //   text-align: center;
                }
                .el-input__icon {
                  line-height: 30px;
                }
              }
            }
          }
        }
        .conditions_list_item_show {
          overflow: visible;
        }
      }
    }
  }

  .sales_list_wrap {
    .el-table {
      .el-table td,
      // .el-table th {
      //   // text-align: center;
      // }
      .el-table__header-wrapper {
        tr {
          > th:first-child {
            // border-right: none;
            .cell {
              // text-align: right;
              text-align: center;
              // padding: 0;
              // .el-checkbox {
              //   // right: 0;
              // }
            }
          }
          > th:nth-child(2) {
            .cell {
              text-align: center;
              // .el-checkbox {
              //   // right: 0;
              // }
            }
          }
        }
      }
      .el-table__body-wrapper {
        .el-table__row {
          // > td {
          //   // padding: 6px 0;
          // }
          // td:first-child {
          //   // border-right: none;
          //   .cell {
          //     // text-align: right;
          //     // padding: 0;
          //   }
          // }
          td:nth-child(2) {
            .cell {
              text-align: center;
            }
          }
        }
      }
    }
  }

  .footer_page {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: top;
    margin-bottom: 20px;
    padding: 0 50px;
    // position: absolute;
    // bottom: 0;
    // right: 50px;
    .sales_header_rigth {
      display: flex;
      .el-dropdown {
        .el-button--primary {
          width: 140px;
          height: 30px;
          line-height: 0;
        }
      }

      .sales_contrast {
        min-width: 56px;
        padding: 4px 8px;
        background: #f5f5f5;
        margin-right: 24px;
        font-size: 14px;
        color: #ffffff;
        background: #5e75e6;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;

        .icon-icon_duibi {
          font-size: 24px;
        }
        .icon-icon_tongji {
          font-size: 24px;
        }
        .icon-icon_daochu {
          font-size: 24px;
        }
        .icon-icon_shoucang {
          font-size: 24px;
        }
      }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #5e75e6;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border: 1px solid #ccc;
      background: white;
    }

    // .el-icon-arrow-left:before {
    //   content: "上一页";
    //   padding: 0 20px;
    //   color: #cccccc;
    //   font-size: 12px;
    // }

    // .el-icon-arrow-right:before {
    //   content: "下一页";
    //   padding: 0 20px;
    //   color: #cccccc;
    //   font-size: 12px;
    // }
  }
}
</style>
